<template>
    <span
        class="inline-flex items-center px-1.5 py-0.5 rounded text-xs align-middle font-medium"
        :class="getClassBasedOnStatus()"
    >
        {{ getTextBasedOnStatus() }}
    </span>
</template>

<script>
export default {
    name: "LeadStatus",
    props: ['status'],
    data() {
        return {}
    },
    methods: {
        getClassBasedOnStatus() {
            switch (this.status) {
                case null:
                    return ''
                case 'submitted':
                    return 'border border-custom-text'
                case 'converted':
                    return 'border border-custom-text'
                case 'rejected':
                    return 'border bg-pink-100 text-pink-800 border-pink-100'
                default:
                    return 'border bg-gray-100 border-gray-100 text-gray-800'
            }
        },
        getTextBasedOnStatus() {
            switch (this.status) {
                case null:
                    return 'n/a'
                case 'submitted':
                    return 'Submitted'
                case 'converted':
                    return 'Converted'
                case 'rejected':
                    return 'Rejected'
                default:
                    return this.status.charAt(0).toUpperCase() + this.status.slice(1);
            }
        }
    }
}
</script>
